export const Availability: React.FC = () => {
	return <h3>En construcción...</h3>;
};
